/* drawer-qty-v12 + drawer-refresh-20261007 + cart-note-v2 */
(function () {
  var busy = false;
  var moneyFormat = (window.theme && theme.moneyFormat) ||
    (window.Shopify && Shopify.money_format) ||
    '$ {{amount}}';

  function ensureBackdrop() {
    var el = document.querySelector('.iron-cart-drawer-backdrop');
    if (!el) {
      el = document.createElement('div');
      el.className = 'iron-cart-drawer-backdrop';
      document.body.appendChild(el);
      el.addEventListener('click', function (e) {
        e.preventDefault();
        closeDrawer();
      });
    }
    return el;
  }
  function cartRoot() {
    return document.querySelector('#ihp-cart-host .tt-cart') ||
      document.querySelector('#iron-site-header .tt-cart') ||
      document.querySelector('.tt-cart');
  }
  function drawerPanel() {
    var root = cartRoot();
    return root ? root.querySelector('.tt-dropdown-menu.iron-cart-drawer') : null;
  }
  function isOpen() {
    var root = cartRoot();
    return !!(root && (root.classList.contains('active') || root.classList.contains('activetoview')));
  }
  function visibleLineCount(panel) {
    var visible = 0;
    panel.querySelectorAll('.tt-cart-list > .tt-item').forEach(function (el) {
      if (window.getComputedStyle(el).display !== 'none') visible++;
    });
    return visible;
  }
  function syncEmptyFilled() {
    var panel = drawerPanel();
    if (!panel) return;
    var count = visibleLineCount(panel);
    var empty = panel.querySelector('.tt-cart-empty');
    var box = panel.querySelector('.tt-cart-box');
    if (empty) {
      if (count > 0) empty.classList.add('hide');
      else empty.classList.remove('hide');
    }
    if (box) {
      if (count > 0) box.classList.remove('hide');
      else box.classList.add('hide');
    }
  }
  function updateTitleCount(itemCount) {
    var panel = drawerPanel();
    if (!panel) return;
    syncEmptyFilled();
    var title = panel.querySelector('.iron-cart-drawer__head .tt-title');
    if (!title) return;
    var n;
    if (typeof itemCount === 'number') {
      n = itemCount;
    } else {
      n = 0;
      panel.querySelectorAll('.tt-cart-list > .tt-item').forEach(function (el) {
        if (window.getComputedStyle(el).display === 'none') return;
        var input = el.querySelector('.iron-drawer-qty-input');
        var q = input ? parseInt(input.value, 10) : 0;
        if (!q) {
          var qtySpan = el.querySelector('.qty');
          q = qtySpan ? parseInt(String(qtySpan.textContent || '').replace(/\D/g, ''), 10) : 1;
        }
        n += (q && !isNaN(q) ? q : 1);
      });
    }
    if (n <= 0) title.textContent = 'Carrito';
    else title.textContent = 'Carrito · ' + n + (n === 1 ? ' artículo' : ' artículos');
  }
  function enablePanelScroll() {
    var panel = drawerPanel();
    if (!panel) return;
    panel.style.overflowY = 'scroll';
    panel.style.webkitOverflowScrolling = 'touch';
    panel.style.touchAction = 'pan-y';
    panel.style.maxHeight = '100dvh';
    panel.style.height = '100dvh';
  }
  var wasOpen = false;
  function sync() {
    ensureBackdrop();
    var open = isOpen();
    document.body.classList.toggle('iron-cart-drawer-open', open);
    document.documentElement.classList.toggle('iron-cart-drawer-open', open);
    if (open) {
      enablePanelScroll();
      updateTitleCount();
      hydrateAllLines();
      if (!wasOpen) scheduleRefresh(0);
    }
    wasOpen = open;
  }
  function closeDrawer() {
    var root = cartRoot();
    if (!root) return;
    root.classList.remove('active', 'activetoview');
    document.body.classList.remove('tt-popup-dropdown', 'iron-cart-drawer-open');
    document.documentElement.classList.remove('iron-cart-drawer-open');
  }

  function formatMoney(cents) {
    cents = Math.round(Number(cents) || 0);
    if (window.Shopify && typeof Shopify.formatMoney === 'function') {
      try { return Shopify.formatMoney(cents, moneyFormat); } catch (e) {}
    }
    var amount = (cents / 100).toFixed(2);
    var withComma = amount.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    if (typeof moneyFormat === 'string' && moneyFormat.indexOf('{{amount}}') !== -1) {
      return moneyFormat.replace('{{amount}}', withComma);
    }
    return '$ ' + withComma;
  }

  function updateBadgesAndTotal(cart, silent) {
    var count = cart.item_count || 0;
    var priceStr = formatMoney(cart.total_price);
    document.querySelectorAll('.tt-badge-cart').forEach(function (el) {
      el.textContent = String(count);
      if (count === 0) el.classList.add('hide');
      else el.classList.remove('hide');
    });
    document.querySelectorAll('.tt-cart-total-price').forEach(function (el) {
      el.innerHTML = priceStr;
    });
    if (typeof window.ihpSyncCartBadge === 'function') {
      window.ihpSyncCartBadge(count);
    }
    updateMsi(cart.total_price);
    updateTitleCount(count);
    /* silent: refresco tras ATC/re-render; no emitir cart:updated porque theme.liquid abre el drawer con ese evento */
    if (silent) return;
    try {
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
    } catch (e) {}
  }

  function updateMsi(totalCents) {
    var el = document.querySelector('[data-iron-msi-cart]');
    if (!el) return;
    totalCents = Number(totalCents) || 0;
    if (totalCents <= 0) {
      el.style.display = 'none';
      return;
    }
    el.style.display = '';
    var months = 6;
    if (totalCents >= 1500000) months = 12;
    else if (totalCents >= 500000) months = 9;
    var monthly = Math.floor((totalCents + months - 1) / months);
    var strongs = el.querySelectorAll('strong');
    if (strongs[0]) strongs[0].textContent = formatMoney(monthly);
    if (strongs[1]) strongs[1].textContent = months + ' meses sin intereses';
  }

  function findCartItem(cart, lineEl) {
    var key = lineEl.getAttribute('data-line-key') || '';
    var vid = String(lineEl.getAttribute('data-variant-id') || '');
    var items = cart.items || [];
    var i, it;
    if (key) {
      for (i = 0; i < items.length; i++) {
        if (String(items[i].key) === String(key)) return items[i];
      }
    }
    for (i = 0; i < items.length; i++) {
      it = items[i];
      if (String(it.key) === vid || String(it.id) === vid || String(it.variant_id) === vid) return it;
    }
    return null;
  }

  function setBtnVisibility(lineEl, qty, max) {
    var minus = lineEl.querySelector('.iron-drawer-minus');
    var plus = lineEl.querySelector('.iron-drawer-plus');
    if (minus) minus.style.visibility = qty <= 1 ? 'hidden' : 'visible';
    if (plus) plus.style.visibility = (max && qty >= max) ? 'hidden' : 'visible';
  }

  function applyLineFromItem(lineEl, item) {
    var input = lineEl.querySelector('.iron-drawer-qty-input');
    var priceEl = lineEl.querySelector('.iron-cart-drawer__line-total');
    var qtySpan = lineEl.querySelector('.qty');
    var qty = item.quantity;
    var max = 100000;
    var counter = lineEl.querySelector('.iron-cart-drawer__qty');
    if (counter && counter.getAttribute('data-max')) {
      max = parseInt(counter.getAttribute('data-max'), 10) || 100000;
    }
    if (input) {
      input.value = String(qty);
      input.setAttribute('data-variant-id', String(item.id || item.variant_id || ''));
      if (item.key) input.setAttribute('data-line-key', item.key);
    }
    if (item.key) lineEl.setAttribute('data-line-key', item.key);
    lineEl.setAttribute('data-variant-id', String(item.id || item.variant_id || ''));
    lineEl.setAttribute('data-line-qty', String(qty));
    if (qtySpan) qtySpan.textContent = String(qty);
    if (priceEl) {
      var linePrice = (typeof item.final_line_price === 'number') ? item.final_line_price : item.line_price;
      priceEl.textContent = formatMoney(linePrice);
    }
    setBtnVisibility(lineEl, qty, max);
  }

  function removeLine(lineEl) {
    if (lineEl && lineEl.parentNode) lineEl.parentNode.removeChild(lineEl);
  }

  function changeLineQty(lineEl, newQty) {
    if (!lineEl || busy) return;
    var input = lineEl.querySelector('.iron-drawer-qty-input');
    var key = (input && input.getAttribute('data-line-key')) || lineEl.getAttribute('data-line-key') || '';
    var vid = (input && input.getAttribute('data-variant-id')) || lineEl.getAttribute('data-variant-id') || '';
    // Prefer line key; fall back to variant id
    var id = key || vid;
    if (!id || id === '0') return;

    var counter = lineEl.querySelector('.iron-cart-drawer__qty');
    var max = 100000;
    if (counter && counter.getAttribute('data-max')) {
      max = parseInt(counter.getAttribute('data-max'), 10) || 100000;
    }
    newQty = parseInt(newQty, 10);
    if (isNaN(newQty) || newQty < 0) newQty = 0;
    if (newQty > max) newQty = max;

    // Optimistic UI
    if (input && newQty > 0) input.value = String(newQty);
    lineEl.setAttribute('data-line-qty', String(newQty));

    busy = true;
    if (counter) counter.classList.add('is-busy');

    function finish(cart) {
      busy = false;
      if (counter) counter.classList.remove('is-busy');
      if (!cart) return;
      var item = findCartItem(cart, lineEl);
      if (!item || newQty === 0) {
        removeLine(lineEl);
      } else {
        applyLineFromItem(lineEl, item);
      }
      var panel = drawerPanel();
      if (panel) {
        var list = panel.querySelector('.tt-cart-list');
        if (list) {
          Array.prototype.forEach.call(list.children, function (el, idx) {
            if (!el.classList || !el.classList.contains('tt-item')) return;
            el.style.display = idx > 7 ? 'none' : '';
          });
        }
      }
      updateBadgesAndTotal(cart);
      syncEmptyFilled();
      // Keep drawer open after qty change (theme may clear .active)
      var root = cartRoot();
      if (root && document.body.classList.contains('iron-cart-drawer-open')) {
        root.classList.add('active', 'activetoview');
        var p = drawerPanel();
        if (p) {
          p.style.setProperty('display', 'block', 'important');
          enablePanelScroll();
        }
      }
      if (typeof window.addToCartHandler !== 'undefined' && addToCartHandler.updateGeneralInfo) {
        try { addToCartHandler.updateGeneralInfo(cart); } catch (e) {}
      }
    }

    function fail(err) {
      busy = false;
      if (counter) counter.classList.remove('is-busy');
      // Revert optimistic qty from server
      fetch('/cart.js', { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var item = findCartItem(cart, lineEl);
          if (item) applyLineFromItem(lineEl, item);
          updateBadgesAndTotal(cart);
        })
        .catch(function () {});
      if (window.console) console.warn('[iron-cart-drawer] qty change failed', err);
    }

    // Use fetch (not Shopify.changeItem) so we always get the cart and avoid theme side-effects
    var body;
    var headers = { 'Accept': 'application/json' };
    // line key may contain ':' — JSON body is safest
    headers['Content-Type'] = 'application/json';
    body = JSON.stringify({ id: id, quantity: newQty });

    fetch('/cart/change.js', {
      method: 'POST',
      headers: headers,
      body: body,
      credentials: 'same-origin'
    }).then(function (r) {
      if (!r.ok) throw new Error('HTTP ' + r.status);
      return r.json();
    }).then(finish).catch(fail);
  }

  function hydrateLine(lineEl) {
    if (!lineEl) return;
    if (!lineEl.querySelector('.iron-drawer-qty-input')) {
      upgradeLegacyLine(lineEl);
    }
    var del = lineEl.querySelector('.header_delete_cartitem_js');
    if (del && (!lineEl.getAttribute('data-variant-id') || lineEl.getAttribute('data-variant-id') === '0')) {
      var m = String(del.getAttribute('href') || '').match(/id=(\d+)/);
      if (m) {
        lineEl.setAttribute('data-variant-id', m[1]);
        var inp = lineEl.querySelector('.iron-drawer-qty-input');
        if (inp) inp.setAttribute('data-variant-id', m[1]);
      }
    }
    // Only pull from theme .qty when ATC just cloned (input still default / blank key)
    if (lineEl.getAttribute('data-iron-qty-ready') !== '1') {
      syncQtyFromTheme(lineEl);
      lineEl.setAttribute('data-iron-qty-ready', '1');
    }
  }

  function syncQtyFromTheme(lineEl) {
    if (!lineEl) return;
    var qtySpan = lineEl.querySelector('.qty');
    var input = lineEl.querySelector('.iron-drawer-qty-input');
    if (!qtySpan || !input) return;
    var t = String(qtySpan.textContent || '').replace(/\D/g, '');
    if (t && t !== 'qty') {
      var n = parseInt(t, 10);
      if (!isNaN(n) && n > 0) {
        input.value = String(n);
        lineEl.setAttribute('data-line-qty', String(n));
        var max = 100000;
        var counter = lineEl.querySelector('.iron-cart-drawer__qty');
        if (counter && counter.getAttribute('data-max')) {
          max = parseInt(counter.getAttribute('data-max'), 10) || 100000;
        }
        setBtnVisibility(lineEl, n, max);
      }
    }
  }

  function upgradeLegacyLine(lineEl) {
    var meta = lineEl.querySelector('.tt-item-descriptions') || lineEl.querySelector('.iron-cart-drawer__line-meta');
    if (!meta) return;
    var qtyEl = meta.querySelector('.tt-quantity');
    var priceEl = meta.querySelector('.tt-price');
    var qty = 1;
    if (qtyEl) {
      var qm = String(qtyEl.textContent || '').match(/(\d+)/);
      if (qm) qty = parseInt(qm[1], 10) || 1;
    }
    var priceHtml = priceEl ? priceEl.innerHTML : '';
    if (qtyEl) qtyEl.parentNode.removeChild(qtyEl);
    if (priceEl) priceEl.parentNode.removeChild(priceEl);
    var link = lineEl.querySelector(':scope > a');
    if (link && !link.classList.contains('iron-cart-drawer__line-link')) {
      link.classList.add('iron-cart-drawer__line-link');
    }
    var controls = document.createElement('div');
    controls.className = 'iron-cart-drawer__line-controls';
    controls.innerHTML =
      '<div class="tt-input-counter style-01 input-counter iron-cart-drawer__qty" data-max="100000">' +
        '<span class="iron-drawer-minus" role="button" tabindex="0" aria-label="Menos"></span>' +
        '<input class="iron-drawer-qty-input" type="text" inputmode="numeric" value="' + qty + '" size="100000" aria-label="Cantidad">' +
        '<span class="iron-drawer-plus" role="button" tabindex="0" aria-label="Más"></span>' +
      '</div>' +
      '<div class="tt-price iron-cart-drawer__line-total">' + priceHtml + '</div>' +
      '<span class="qty hide" aria-hidden="true">' + qty + '</span>';
    lineEl.appendChild(controls);
    setBtnVisibility(lineEl, qty, 100000);
  }

  function hydrateAllLines() {
    var panel = drawerPanel();
    if (!panel) return;
    panel.querySelectorAll('.tt-cart-list > .tt-item').forEach(hydrateLine);
  }

  function lineFromEventTarget(t) {
    return t && t.closest ? t.closest('.iron-cart-drawer .tt-item, .tt-cart-list > .tt-item') : null;
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.iron-cart-drawer__close');
    if (btn) {
      e.preventDefault();
      e.stopPropagation();
      closeDrawer();
      return;
    }
    var minus = e.target.closest && e.target.closest('.iron-cart-drawer .iron-drawer-minus');
    var plus = e.target.closest && e.target.closest('.iron-cart-drawer .iron-drawer-plus');
    if (!minus && !plus) return;
    e.preventDefault();
    e.stopPropagation();
    if (e.stopImmediatePropagation) e.stopImmediatePropagation();
    var line = lineFromEventTarget(e.target);
    if (!line) return;
    var input = line.querySelector('.iron-drawer-qty-input');
    var cur = parseInt(input && input.value, 10) || 1;
    changeLineQty(line, plus ? cur + 1 : Math.max(0, cur - 1));
  }, true);

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.key !== ' ') return;
    var minus = e.target.closest && e.target.closest('.iron-cart-drawer .iron-drawer-minus');
    var plus = e.target.closest && e.target.closest('.iron-cart-drawer .iron-drawer-plus');
    if (!minus && !plus) return;
    e.preventDefault();
    var line = lineFromEventTarget(e.target);
    if (!line) return;
    var input = line.querySelector('.iron-drawer-qty-input');
    var cur = parseInt(input && input.value, 10) || 1;
    changeLineQty(line, plus ? cur + 1 : Math.max(0, cur - 1));
  }, true);

  document.addEventListener('change', function (e) {
    var input = e.target;
    if (!input || !input.classList || !input.classList.contains('iron-drawer-qty-input')) return;
    if (!input.closest('.iron-cart-drawer')) return;
    var line = lineFromEventTarget(input);
    if (!line) return;
    changeLineQty(line, input.value);
  }, true);


  /* drawer-refresh-20261007: el ATC de Wokiee (vendor.min.js addToCartHandler.addItem/updateGeneralInfo) solo
     actualiza $('header').find('.tt-cart'), es decir, el carrito del header Wokiee viejo (oculto). El drawer Iron vive en
     #ihp-cart-host, fuera de <header>, así que se quedaba vacío ("Tu carrito está vacío") y el badge en 0 hasta recargar.
     Solución: cuando cualquier request a /cart/add|change|update|clear termina (fetch o XHR/jQuery: Wokiee, Boost,
     Kaching, etc.) y cada vez que se abre el drawer, se lee /cart.js y se reconstruyen las líneas del drawer Iron,
     el badge, el subtotal, el MSI y el estado vacío/lleno. Si las líneas ya coinciden con el carrito, no se re-pinta. */
  var refreshTimer = null, refreshSeq = 0;
  var CART_MUT_RE = /\/cart\/(add|change|update|clear)(\.js|\.json)?(\?|$)/;
  function esc(v) {
    return String(v == null ? '' : v).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function imgUrl(item) {
    var u = item.image || (item.featured_image && item.featured_image.url) || '';
    if (!u) return '';
    return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=120';
  }
  function lineTemplate() {
    var tpl = document.querySelector('#ihp-cart-host .item-html-js .tt-item') || document.querySelector('.item-html-js .tt-item');
    return tpl ? tpl.cloneNode(true) : null;
  }
  function buildLine(item, idx) {
    var el = lineTemplate();
    if (!el) return null;
    var vid = String(item.variant_id || item.id || '');
    var qty = item.quantity;
    el.setAttribute('data-variant-id', vid);
    el.setAttribute('data-line-key', item.key || '');
    el.setAttribute('data-line-qty', String(qty));
    el.setAttribute('data-iron-qty-ready', '1');
    if (idx > 7) el.style.display = 'none';
    var link = el.querySelector('.iron-cart-drawer__line-link') || el.querySelector(':scope > a');
    if (link) link.setAttribute('href', item.url || '#');
    var imgBox = el.querySelector('.tt-item-img');
    if (imgBox) {
      var src = imgUrl(item);
      imgBox.innerHTML = src ? '<img src="' + esc(src) + '" alt="' + esc(item.product_title) + '" width="64" height="64" loading="eager">' : '';
    }
    var title = el.querySelector('.tt-title');
    if (title) title.textContent = item.product_title || item.title || '';
    var details = el.querySelector('.details');
    var vt = item.variant_title;
    if (details) {
      if (!vt || vt === 'Default Title' || item.product_has_only_default_variant) {
        var ul = details.closest('ul'); if (ul) ul.parentNode.removeChild(ul);
      } else {
        details.textContent = String(vt).replace(/ \/ /g, ', ');
      }
    }
    var del = el.querySelector('.header_delete_cartitem_js');
    if (del) del.setAttribute('href', String(del.getAttribute('href') || '/cart/change?id=0&quantity=0').replace(/id=\d+/, 'id=' + vid));
    var input = el.querySelector('.iron-drawer-qty-input');
    if (input) {
      input.value = String(qty);
      input.setAttribute('data-variant-id', vid);
      input.setAttribute('data-line-key', item.key || '');
    }
    var priceEl = el.querySelector('.iron-cart-drawer__line-total');
    if (priceEl) {
      var fin = (typeof item.final_line_price === 'number') ? item.final_line_price : item.line_price;
      var orig = (typeof item.original_line_price === 'number') ? item.original_line_price : fin;
      priceEl.innerHTML = (orig !== fin ? '<span class="tt-price-old">' + esc(formatMoney(orig)) + '</span> ' : '') + esc(formatMoney(fin));
    }
    var qtySpan = el.querySelector('.qty');
    if (qtySpan) qtySpan.textContent = String(qty);
    setBtnVisibility(el, qty, 100000);
    return el;
  }
  function domSignature(list) {
    var sig = [];
    Array.prototype.forEach.call(list.children, function (el) {
      if (!el.classList || !el.classList.contains('tt-item')) return;
      sig.push((el.getAttribute('data-line-key') || el.getAttribute('data-variant-id') || '?') + 'x' + (el.getAttribute('data-line-qty') || '?'));
    });
    return sig.join('|');
  }
  function renderFromCart(cart) {
    if (!cart || !cart.items) return;
    var panel = drawerPanel();
    if (panel) {
      var list = panel.querySelector('.tt-cart-list');
      if (list && !busy) {
        var want = cart.items.map(function (it) { return it.key + 'x' + it.quantity; }).join('|');
        if (domSignature(list) !== want) {
          var frag = document.createDocumentFragment(), ok = true;
          cart.items.forEach(function (it, i) { var el = buildLine(it, i); if (el) frag.appendChild(el); else ok = false; });
          if (ok) { list.innerHTML = ''; list.appendChild(frag); }
        } else {
          /* misma composición: refrescar precio de cada línea (p. ej. llegó un cupón) */
          Array.prototype.forEach.call(list.querySelectorAll(':scope > .tt-item'), function (el) {
            var it = findCartItem(cart, el); if (it) applyLineFromItem(el, it);
          });
        }
      }
      var more = panel.querySelector('.header-cart-more-message-js');
      if (more) more.style.display = cart.items.length > 3 ? '' : 'none';
      var empty = panel.querySelector('.tt-cart-empty');
      var box = panel.querySelector('.tt-cart-box');
      if (empty) empty.classList.toggle('hide', cart.item_count > 0);
      if (box) box.classList.toggle('hide', cart.item_count === 0);
    }
    updateBadgesAndTotal(cart, true);
    /* cart-note-v2: avisar a ieliq-badge (context cartmap) con el /cart.js ya leído; NO es cart:updated (ese abre el drawer) */
    try { document.dispatchEvent(new CustomEvent('iron:cart-rendered', { detail: cart })); } catch (e) {}
  }
  function refreshFromServer() {
    var seq = ++refreshSeq;
    return fetch('/cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { if (seq === refreshSeq) renderFromCart(cart); })
      .catch(function () {});
  }
  function scheduleRefresh(delay) {
    if (refreshTimer) clearTimeout(refreshTimer);
    refreshTimer = setTimeout(function () { refreshTimer = null; refreshFromServer(); }, typeof delay === 'number' ? delay : 250);
  }
  window.ironCartRefresh = refreshFromServer;
  (function hookNetwork() {
    if (window.__ironCartNetHook) return;
    window.__ironCartNetHook = true;
    if (window.fetch) {
      var of = window.fetch;
      window.fetch = function (input, init) {
        var url = typeof input === 'string' ? input : (input && input.url) || '';
        var p = of.apply(this, arguments);
        if (CART_MUT_RE.test(url)) {
          p.then(function () { scheduleRefresh(); }, function () { scheduleRefresh(); });
        }
        return p;
      };
    }
    if (window.XMLHttpRequest) {
      var oo = XMLHttpRequest.prototype.open;
      XMLHttpRequest.prototype.open = function (m, url) {
        try {
          if (CART_MUT_RE.test(String(url || '')) && !this.__ironCartHooked) {
            this.__ironCartHooked = true;
            this.addEventListener('loadend', function () { scheduleRefresh(); });
          }
        } catch (e) {}
        return oo.apply(this, arguments);
      };
    }
  })();
  window.addEventListener('pageshow', function (e) { if (e.persisted) scheduleRefresh(0); });

  document.addEventListener('DOMContentLoaded', function () {
    /* plantilla /cart: menu-cart no se renderiza y ihpSyncCartBadge deja el badge en 0; sincronizar desde /cart.js */
    if (!document.querySelector('#ihp-cart-host .tt-badge-cart')) scheduleRefresh(0);
    ensureBackdrop();
    var root = cartRoot();
    if (!root) return;
    var obs = new MutationObserver(sync);
    obs.observe(root, { attributes: true, attributeFilter: ['class'] });
    var panel = drawerPanel();
    if (panel) {
      var list = panel.querySelector('.tt-cart-list');
      if (list) {
        new MutationObserver(function (mutations) {
          var added = false;
          mutations.forEach(function (m) {
            if (m.addedNodes && m.addedNodes.length) added = true;
          });
          if (added) {
            updateTitleCount();
            hydrateAllLines();
          } else {
            syncEmptyFilled();
          }
        }).observe(list, { childList: true, subtree: false });
      }
    }
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && isOpen()) closeDrawer();
    });
    hydrateAllLines();
    sync();
  });
})();
